import React from 'react'
import { ToastContainer, ToastContainerProps } from 'react-toastify'

const TOAST_LIMIT = 4

export const ToastProvider = (props: ToastContainerProps) => {
  return (
    <ToastContainer
      {...{
        limit: TOAST_LIMIT,
        closeButton: false,
        hideProgressBar: true,
        ...props,
      }}
    />
  )
}
